import { BsKeyboardFill } from "react-icons/bs";

const Header = () => {
    return ( 
        <div className="header">
            <BsKeyboardFill style={{fontSize:'60px', color:'rgb(111, 59, 231)'}}/>
            <h2>TypingTest</h2>
        </div> 
    );
}
 
export default Header;